import { render, staticRenderFns } from "./select-colors.vue?vue&type=template&id=1a2bbe50&"
import script from "./select-colors.vue?vue&type=script&lang=ts&"
export * from "./select-colors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports